import getConfig from 'next/config';

export const GA_TRACKING_ID = getConfig().publicRuntimeConfig.GA_TRACKING_ID;

// https://developers.google.com/analytics/devguides/collection/gtagjs
//
// Notes:
//   - Pageviews are sent automatically based on location change, or push/pop state. This means no
//     explicit pageviews are sent in the app.
//

export const setUserId = (subscriberId: string): void => {
  if (window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      user_id: subscriberId,
    });
  }
};
